import { Alert, Box, Grid } from '@mui/material'
import HeroSection from './HeroSection'
import PostDetail from '../admin/PostDetail'
import { useAppSelector } from '../../hooks'
import { useEffect, useMemo, useState } from 'react'
import { PostType } from '../../types/types'
import PostCard from '../../components/post/PostCard'

const JobDetailAndRelated = () => {
    const { data } = useAppSelector(state=> state.post)
    const [ relatedPosts,setRelatedPosts ] = useState<PostType[]>([])

    const eachPost = useMemo(() => (
        relatedPosts.length > 0 &&
        relatedPosts.map((post: PostType, index: number) => (
          <Grid item xs={12} key={index} sx={{ mb: 3 }}>
            <PostCard index={index} post={post} />
          </Grid>
        ))
      ), [relatedPosts]);

    useEffect(()=>{
        if(data && data.data && data.data.relatedPosts){
            setRelatedPosts(data.data.relatedPosts);            
        }
    },[data])
  return (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
        }}
    >
        <HeroSection/>
        <Box sx={{ width: "100%", px: { xs: 1, md: 3 }, py: 5 }}>
            <Grid container spacing={2} sx={{ mt: 2, display: 'flex', flexDirection: { xs: 'column-reverse', md: 'row' } }}>
                <Grid item xs={12} md={3}>
                    {relatedPosts.length > 0 ? eachPost : (
                        <Grid item xs={12}>
                            <Alert severity="warning" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>No related posts found.</Alert>
                        </Grid>
                    )}
                </Grid>
                <Grid item xs={12} md={9}>
                    <PostDetail/>
                </Grid>
            </Grid>
        </Box>
    </Box>
  )
}

export default JobDetailAndRelated
